export default __webpack_public_path__ + "static/media/account.35fb837c.png";